import { useCallback } from 'react';
import { IconButton } from 'mastodon/components/icon_button';
import { useAppDispatch } from 'mastodon/store';
import { fetchAccount } from 'mastodon/actions/accounts';
import { closeModal } from 'mastodon/actions/modal';
import api from 'mastodon/api';
import { CloseIcon } from 'mastodon/components/icons/close';
import {laoidDomain}  from 'mastodon/initial_state';

interface Props {
  accessToken: string;
  accountId: string;
}

export const LaoIdProfileModal: React.FC<Props> = ({ accessToken, accountId }) => {
  const dispatch = useAppDispatch();

  const handleClose = useCallback(async () => {
    try {
      await api().post('/api/v1/auth/laoid/update_user', {
        access_token: accessToken
      });

      // Update the account before closing
      dispatch(fetchAccount(accountId));

      // Close the modal
      dispatch(closeModal({
        modalType: 'LAOID_PROFILE',
        ignoreFocus: false,
      }));
    } catch (error) {
      console.error('Error updating user information:', error);
      // Still close the modal even if there was an error
      dispatch(closeModal({
        modalType: 'LAOID_PROFILE',
        ignoreFocus: false,
      }));
    }
  }, [dispatch, accountId]);
  console.log('Rendering LaoIdProfileModal with accessToken:', laoidDomain, accessToken);
  return (
    <div className='modal-root__modal laoid-profile-modal'>
      <div className='laoid-profile-modal__header'>
        <IconButton
          className='laoid-profile-modal__close'
          title={''}
          label={''}
          icon='times'
          iconComponent={CloseIcon}
          onClick={handleClose}
        />
      </div>
      <iframe
        src={`${laoidDomain}/me?accessToken=${accessToken}`}
        className='laoid-profile-modal__iframe'
        title='LaoID Profile'
      />
    </div>
  );
};
